// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://sonicscan.org/address/0xEB0682d148e874553008730f0686ea89db7DA412
export const TRANSPARENT_PROXY_FACTORY = '0xEB0682d148e874553008730f0686ea89db7DA412';

// https://sonicscan.org/address/0xA4aF5175ed38e791362F01c67a487DbA4aE07dFe
export const PROTOCOL_GUARDIAN = '0xA4aF5175ed38e791362F01c67a487DbA4aE07dFe';

// https://sonicscan.org/address/0x22740deBa78d5a0c24C58C740e3715ec29de1bFa
export const AFC_SAFE = '0x22740deBa78d5a0c24C58C740e3715ec29de1bFa';

// https://sonicscan.org/address/0xdef1FA4CEfe67365ba046a7C630D6B885298E210
export const MASIV_SAFE = '0xdef1FA4CEfe67365ba046a7C630D6B885298E210';

// https://sonicscan.org/address/0x9eFf17b168867Dc2bCD87D2Ab44e4857902dbC29
export const REWARD_STEWARD = '0x9eFf17b168867Dc2bCD87D2Ab44e4857902dbC29';

export const CHAIN_ID = 146;
